import React, { useState, useRef, useEffect } from 'react';
import { apiRequest } from '../../api/index';
import ToastUtils from '../../utils/toast';
import images from "../../images";

const ApplyForMarriageModal = ({ isOpen, onClose, leads }) => {
  const [comment, setComment] = useState('');
  const [loading, setLoading] = useState(false);
  const [showHelpTooltip, setShowHelpTooltip] = useState(false);
  const tooltipRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (tooltipRef.current && !tooltipRef.current.contains(event.target)) {
        setShowHelpTooltip(false);
      }
    };

    if (showHelpTooltip) {
      document.addEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [showHelpTooltip]);

  if (!isOpen) return null;

  const handleSubmit = async () => {
    if (!leads || leads.length === 0) {
      ToastUtils.error('Нет идентификаций для обработки');
      return;
    }

    setLoading(true);
    try {
      // Проходимся по всем лидам и выполняем PATCH запрос
      // const data_request = {
      //   reject: true,
      //   comment: comment
      // }
      const data_request = {
        reject: true,
        comment_reject: comment
      }
      for (const lead of leads) {
        await apiRequest(`leads/${lead.id}/update`, 'PATCH', data_request);
      }

      ToastUtils.success('Заявления успешно поданы');
      onClose();
    } catch (error) {
      console.error('Ошибка при подаче заявления:', error);
      ToastUtils.error('Ошибка при подаче заявления');
    } finally {
      setLoading(false);
    }
  };

  return (
      <div className="modal-overlay" onClick={onClose}>
        <div
            className="modal small bottom-right open"
            onClick={(e) => e.stopPropagation()}
        >
          <div className="modal-header">
            <h3>Заявление на брак</h3>
          </div>
          <div className="modal-body">
            <div className="comment-label-container">
                <h5>Комментарий</h5>
                <div className="help-icon-container" onClick={() => setShowHelpTooltip(!showHelpTooltip)}>
                  <img
                      src={images.questionActive}
                      alt="Справка"
                      className="help-icon"
                  />
                  {showHelpTooltip && (
                      <div className="help-tooltip" ref={tooltipRef}>
                        <div className="help-tooltip-content">
                          <p>Вставьте ссылку на файл, чтобы обозначить факт брака идентификаций</p>
                        </div>
                      </div>
                  )}
              </div>
            </div>

            <textarea
                className="form-control"
                placeholder="Введите комментарий..."
                rows="3"
                value={comment}
                onChange={(e) => setComment(e.target.value)}
            ></textarea>
          </div>
          <div className="modal-footer">
            <button
                type="button"
                className="btn btn-primary-filled"
                onClick={handleSubmit}
                disabled={loading}
            >
              {loading ? 'Подача...' : 'Подать заявление'}
            </button>
          </div>
        </div>
      </div>
  );
};

export default ApplyForMarriageModal;
